var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{class:[_vm.className, 'w-100'],attrs:{"no-body":_vm.noBody,"border-variant":"light"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }